import { Injectable } from '@angular/core';
import { Observable, of, catchError, map } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { ISalonReviews, ISalonReviewsItem } from '@app/shared/models';
import { extendReviewItem } from '@app/shared/components/review-item/extend-review-item';
import { extendSalonImagesWithDefaults } from '@app/shared/utils/salon';

@Injectable({
  providedIn: 'root'
})
export class SalonService {

  constructor(private http: HttpClient) { }

  getSalonDetails$(salonId: string): Observable<ISalonDetailsApi> {
    return this.http.get<ISalonDetailsApi>(`/api/salons/${salonId}/details`)
      .pipe(map((salonDetails: ISalonDetailsApi) => extendSalonImagesWithDefaults(salonDetails)));
  }

  getSalonDetailsByCityAndAlias$(cityName: string, salonNameAlias: string): Observable<ISalonDetailsApi> {
    return this.http.get<ISalonDetailsApi>(`/api/salons/city/${cityName}/salon/${salonNameAlias}/details`)
      .pipe(map((salonDetails: ISalonDetailsApi) => extendSalonImagesWithDefaults(salonDetails)));
  }

  getSalonReviews$(salonId: string, pageSize: number, pageNumber: number): Observable<ISalonReviews> {
    const url = `/api/salons/${salonId}/reviews/?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    return this.http.get<ISalonReviewsItem[]>(url, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<ISalonReviewsItem[]>) => {
          let reviews = response.body;
          reviews = reviews.map((review: ISalonReviewsItem) => extendReviewItem(review));

          return {
            pageNumber: Number(response.headers.get('X-Paging-PageNumber')),
            pageSize: Number(response.headers.get('X-Paging-PageSize')),
            totalCount: Number(response.headers.get('X-Paging-TotalCount')),
            totalPages: Number(response.headers.get('X-Paging-TotalPages')),
            reviews
          };
        })
      );
  }

  getIfSalonWasVisited$(salonId: string): Observable<boolean> {
    const url = `/api/salons/${salonId}/visited`;
    const defaultResponseOnError = of(false);
    return this.http.get<boolean>(url)
      .pipe(catchError(_x => defaultResponseOnError));
  }
}
